import { __extends, __awaiter, __makeTemplateObject, __decorate, __metadata, __assign as _assign, __generator } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { createPopper } from '../../node_modules/@popperjs/core/dist/esm/popper.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { KeyboardKey, LegacyKeyboardKey } from '../pvd-utils/enums/keyboard-key.js';
import { LayerPosition } from '../pvd-utils/enums/layer-position.js';
import { MutationType } from '../pvd-utils/enums/mutation-type.js';
import { FOCUSABLE_SELECTORS } from '../pvd-utils/constants/focusable-selectors.js';
import { getElement } from '../pvd-utils/scripts/get-element.js';
import { getCloseIfTriggerHiddenPopperModifier } from '../pvd-utils/scripts/get-close-if-trigger-hidden-popper-modifier.js';
import { getCurrentPlacementPopperModifier } from '../pvd-utils/scripts/get-current-placement-popper-modifier.js';
import { getZIndexPopperModifier } from '../pvd-utils/scripts/get-z-index-popper-modifier.js';

var DEFAULT_BOUNDARY = 'clippingParents';
var DEFAULT_DISABLE_FOCUS = false;
var DEFAULT_DISABLE_RETURN_FOCUS = false;
var DEFAULT_DISABLE_OVERFLOW = false;
var DEFAULT_PLACEMENT = LayerPosition.top;
var DEFAULT_OPEN = false;
var DEFAULT_CLOSE_BTN_A11Y_TEXT = 'Close';
var DEFAULT_TRIGGER_TEXT_CONTENT = 'more information';
var DEFAULT_DISABLE_TRIGGER_SLOT_BUTTON = false;
/**
 * Providence Popover component.
 * @see {@link https://providence.fmr.com/components/popover/popover.html|Popover documentation}
 */
var PvdPopover = /** @class */ (function (_super) {
    __extends(PvdPopover, _super);
    function PvdPopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // function to call when user clicks outside Popover
        _this.onClickOutside = function (e) { return (_this.pvdOpen = false); };
        /**
         * Overrides the default aria-label value for the close button
         */
        _this.pvdCloseButtonA11yText = DEFAULT_CLOSE_BTN_A11Y_TEXT;
        /**
         * Prevents the focus being forced onto the popover when opened
         */
        _this.pvdDisableFocus = DEFAULT_DISABLE_FOCUS;
        /**
         * Prevents the focus from returning to the trigger when the popover closes
         */
        _this.pvdDisableReturnFocus = DEFAULT_DISABLE_RETURN_FOCUS;
        /**
         * Prevents the overflow mutation observer from being created or destroyed
         */
        _this.pvdDisableOverflow = DEFAULT_DISABLE_OVERFLOW;
        /**
         * Disables the "button" wrapper functionality from trigger slot
         */
        _this.pvdDisableTriggerSlotButton = DEFAULT_DISABLE_TRIGGER_SLOT_BUTTON;
        /**
         * Shows/Hides the popover element
         */
        _this.pvdOpen = DEFAULT_OPEN;
        /**
         * Set the `aria-label` value of the slotted trigger button
         */
        _this.pvdTriggerButtonA11yText = DEFAULT_TRIGGER_TEXT_CONTENT;
        /**
         * Placement of the popover
         */
        _this.pvdPlacement = DEFAULT_PLACEMENT;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdPopover, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                'pvd-scoped-icon': customElements.get("".concat(this.namespace, "-icon")),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdPopover.prototype, "hasTrigger", {
        // #endregion
        // #region protected methods
        /**
         * Determines if the consumer provided a slotted trigger
         */
        get: function () {
            return this.isSlotUsed('trigger');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdPopover.prototype, "generatedPopoverId", {
        // #endregion
        // #region private methods
        /**
         * Generates a unique ID if one is not provided within the component
         */
        get: function () {
            if (!this._generatedPopoverId) {
                // Id must start with a letter
                this._generatedPopoverId = "pvd-id-".concat(PvdSlotifyBaseComponent.generateRandomNumber());
            }
            return this._generatedPopoverId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdPopover.prototype, "boundary", {
        /**
         * Returns the element reference that was either provided through the pvdBoundary prop, or the result of a querySelector whos value was this.pvdBoundary
         */
        get: function () {
            return getElement(this.pvdBoundary) || DEFAULT_BOUNDARY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdPopover.prototype, "target", {
        /**
         * Returns the element reference that was either provided through the pvdTarget prop, or the result of a querySelector whos value was this.pvdTarget
         */
        get: function () {
            return getElement(this.pvdTarget);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdPopover.prototype, "popperJsModifiers", {
        /**
         * Returns an array of the modifiers used to configure PopperJS instance
         */
        get: function () {
            var currentPlacementModifier = getCurrentPlacementPopperModifier.call(this);
            var zIndexModifier = getZIndexPopperModifier.call(this);
            var closeIfTriggerHiddenModifier = getCloseIfTriggerHiddenPopperModifier.call(this, this.constructor.namespace);
            return [
                currentPlacementModifier,
                zIndexModifier,
                closeIfTriggerHiddenModifier,
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top', 'right', 'bottom', 'left'],
                        boundary: this.boundary,
                    },
                },
                {
                    name: 'offset',
                    options: {
                        offset: [0, 10],
                    },
                },
                {
                    name: 'arrow',
                    options: {
                        element: this._arrowElement,
                        padding: 24,
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true,
                        boundary: this.boundary,
                    },
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Callback when 'pvdOpen' changes
     */
    PvdPopover.prototype.openStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateComplete];
                    case 1:
                        _a.sent();
                        if (this.pvdOpen) {
                            // adds init values for observed
                            this.isContentOverflowing();
                            this.addFirstLastFocusableElements();
                            // if "external target (not slotted)", we manage focus
                            this.focusPopover();
                            // add the click outside listener
                            this.addClickOutsideListener();
                            // Asynchronously updates the popper instance, and returns a promise. Use this for high-frequency updates.
                            // fire the open event
                            this.popper.update();
                            this.dispatchEvent(new CustomEvent('pvd-popover-change', { detail: { open: true } }));
                        }
                        else {
                            // remove the click outside listener
                            this.removeClickOutsideListener();
                            // move focus back to the triggering element
                            this.returnFocus();
                            // remove references to focusable elements
                            this.removeFirstLastFocusableElements();
                            // fire the close event
                            this.dispatchEvent(new CustomEvent('pvd-popover-change', { detail: { open: false } }));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sets the boundary element for the PopperJS 'preventOverflow' and 'flip' modifiers
     */
    PvdPopover.prototype.boundaryStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.popper) {
                            return [2 /*return*/];
                        }
                        this.popper.setOptions({ modifiers: this.popperJsModifiers });
                        return [4 /*yield*/, this.popper.update()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Callback method when 'pvdPlacement' is changed
     */
    PvdPopover.prototype.placementStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.popper) {
                            return [2 /*return*/];
                        }
                        this.popper.setOptions({ placement: this.pvdPlacement });
                        return [4 /*yield*/, this.popper.update()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Callback method when 'pvdTarget' is changed
     */
    PvdPopover.prototype.targetStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // if a popper instance exists, we need to tear down before setting back up
                if (this.popper) {
                    this.removeMutationObservers();
                    this.removePopperInstance();
                }
                // set up new element references, new popper instance, and new mutation observer
                this.addElementReferences();
                this.addPopperInstance();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Sets the zIndex modifier for PopperJS instance
     */
    PvdPopover.prototype.zIndexStateChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.popper) {
                            return [2 /*return*/];
                        }
                        this.popper.setOptions({ modifiers: this.popperJsModifiers });
                        return [4 /*yield*/, this.popper.update()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns and caches a private reference to a generated slot area ID.
     */
    PvdPopover.prototype.generateSlotAreaId = function () {
        if (!this._generatedSlotAreaId) {
            this._generatedSlotAreaId = "pvd-popover-slot-area-id-".concat(PvdSlotifyBaseComponent.generateRandomNumber());
        }
        return this._generatedSlotAreaId;
    };
    /**
     * Sets focus on the close button
     */
    PvdPopover.prototype.focusPopover = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // wait for things to update and chill within PopperJS
                    return [4 /*yield*/, this.updateComplete];
                    case 1:
                        // wait for things to update and chill within PopperJS
                        _a.sent();
                        if (!this.pvdDisableFocus && this._popoverElement) {
                            this._firstFocusablePopoverEl.focus();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns focus to the previously focused element before the popover was opened
     */
    PvdPopover.prototype.returnFocus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // wait for things to update and chill within PopperJS
                    return [4 /*yield*/, this.updateComplete];
                    case 1:
                        // wait for things to update and chill within PopperJS
                        _a.sent();
                        if (!this.pvdDisableReturnFocus && this._returnFocusElement) {
                            this._returnFocusElement.focus();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Captures the internal references for the popover elements
     */
    PvdPopover.prototype.addElementReferences = function () {
        if (this.hasTrigger) {
            var triggerSlot = this.querySelector("s-slot");
            this._triggerElement = this.pvdDisableTriggerSlotButton
                ? triggerSlot.querySelector(FOCUSABLE_SELECTORS)
                : this.querySelector(".pvd-popover__trigger-wrapper");
        }
        else {
            this._triggerElement = this.target;
        }
        this._popoverElement = this.querySelector(".pvd-popover__wrapper");
        this._arrowElement = this._popoverElement.querySelector(".pvd-popover__arrow");
    };
    /**
     * Initializes the popperjs instance and merges user provided options
     */
    PvdPopover.prototype.addPopperInstance = function () {
        // no trigger, no popper
        if (!this._triggerElement) {
            console.warn("PVD Popover: no trigger slot or `pvd-target` specified for '".concat(this, "'"));
            return;
        }
        // popper.js
        if (!this.popper) {
            this.popper = createPopper(this._triggerElement, this._popoverElement, {
                placement: this.pvdPlacement,
                modifiers: this.popperJsModifiers,
            });
        }
    };
    /**
     * Tears down the popperjs instance and sets the internal reference to `undefined`
     */
    PvdPopover.prototype.removePopperInstance = function () {
        if (this.popper) {
            this.popper.destroy();
            this.popper = undefined;
        }
    };
    /**
     * Sets the first and last focusable elements within the popover
     */
    PvdPopover.prototype.addFirstLastFocusableElements = function () {
        // do NOT add await this.updateComplete in this method. IE11 cannot handle the power
        // capture the currently active element, so that we can return to it on close
        this._returnFocusElement = this._triggerElement;
        var preliminaryFocusableEls = Array.from(this._popoverElement.querySelectorAll(FOCUSABLE_SELECTORS));
        // checks to see if any preliminary focusable el has or is within a display:none or visibility:hidden
        var focusableElements = preliminaryFocusableEls.filter(function (currEl) {
            return (currEl.offsetHeight > 0 && getComputedStyle(currEl).visibility.toUpperCase() !== 'HIDDEN');
        });
        if (focusableElements) {
            this._firstFocusablePopoverEl = focusableElements[0];
            this._lastFocusablePopoverEl = focusableElements[focusableElements.length - 1];
        }
    };
    /**
     * Unsets the first and last focusable elements within the popover
     */
    PvdPopover.prototype.removeFirstLastFocusableElements = function () {
        this._firstFocusablePopoverEl = this._lastFocusablePopoverEl = null;
    };
    /**
     * Adds the click handler outside the popover
     */
    PvdPopover.prototype.addClickOutsideListener = function () {
        this._boundClickOutsideHandler = this.clickOutsideEventHandler.bind(this);
        document.body.addEventListener('click', this._boundClickOutsideHandler);
    };
    /**
     * Removes the click handler outside the popover
     */
    PvdPopover.prototype.removeClickOutsideListener = function () {
        document.body.removeEventListener('click', this._boundClickOutsideHandler);
        this._boundClickOutsideHandler = undefined;
    };
    /**
     * Creates mutation observer to watch for content changing within the Popover content area
     */
    PvdPopover.prototype.addContentChangeObserver = function () {
        var _this = this;
        if (!this._contentChangeObserver) {
            this._contentChangeObserver = new MutationObserver(function (mutationsList) {
                _this.contentChangeMutationEventHandler(mutationsList);
            });
        }
    };
    /**
     * Starts observations for changes on elements
     */
    PvdPopover.prototype.observeMutations = function () {
        // content overflow observer
        if (this._contentChangeObserver && this._popoverElement) {
            this._contentChangeObserver.observe(this._popoverElement, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true,
            });
        }
    };
    /**
     * Removes the mutation observers within Popover
     */
    PvdPopover.prototype.removeMutationObservers = function () {
        // content overflow observer
        if (this._contentChangeObserver) {
            this._contentChangeObserver.disconnect();
        }
    };
    /**
     * Inspects the bounding boxes of the content and it's wrapper to determine if the content is scrolling
     */
    PvdPopover.prototype.isContentOverflowing = function () {
        var slotArea = this.querySelector('.pvd-popover__slot-area');
        // needing to round due to IE11 miscalculations
        var slotScrollHeight = Math.round(slotArea === null || slotArea === void 0 ? void 0 : slotArea.scrollHeight);
        var wrapperRectHeight = Math.round(slotArea === null || slotArea === void 0 ? void 0 : slotArea.getBoundingClientRect()['height']);
        // check if the slotted content is taller than the bounding box
        if (slotScrollHeight && wrapperRectHeight) {
            this.pvdContentOverflow = slotScrollHeight > wrapperRectHeight;
        }
    };
    // #endregion
    // #region events
    /**
     * Handles Popover trigger element mouse events (for slotted triggers)
     * @param e Mouse event object
     */
    PvdPopover.prototype.triggerEventHandler = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.stopPropagation();
                        e.preventDefault();
                        // wait for things to update and chill within PopperJS
                        return [4 /*yield*/, this.updateComplete];
                    case 1:
                        // wait for things to update and chill within PopperJS
                        _a.sent();
                        this.pvdOpen = !this.pvdOpen;
                        return [2 /*return*/];
                }
            });
        });
    };
    PvdPopover.prototype.triggerKeyHandler = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var isSpacePressed, isEnterPressed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isSpacePressed = e.key === KeyboardKey.space || e.key === LegacyKeyboardKey.space;
                        isEnterPressed = e.key === KeyboardKey.enter || e.key === LegacyKeyboardKey.enter;
                        if (!(isSpacePressed || isEnterPressed)) return [3 /*break*/, 2];
                        e.stopPropagation();
                        e.preventDefault();
                        // wait for things to update and chill within PopperJS
                        return [4 /*yield*/, this.updateComplete];
                    case 1:
                        // wait for things to update and chill within PopperJS
                        _a.sent();
                        this.pvdOpen = true;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles close button mouse events
     * @param e Mouse event object
     */
    PvdPopover.prototype.closeButtonEventHandler = function (e) {
        e.stopPropagation();
        e.preventDefault();
        this.pvdOpen = false;
    };
    /**
     * Ensures that when the popover is open, the only tabbable elements are witihin the popover
     * @param e, keyboard event
     */
    PvdPopover.prototype.keyboardEventHandler = function (e) {
        var isTabPressed = e.key === KeyboardKey.tab || e.key === LegacyKeyboardKey.tab;
        var isEscapePressed = e.key === KeyboardKey.escape || e.key === LegacyKeyboardKey.escape;
        // TAB or SHIFT+TAB
        if (isTabPressed) {
            if (e.shiftKey) {
                // if shift key pressed for shift + tab combination
                if (document.activeElement === this._firstFocusablePopoverEl) {
                    this._lastFocusablePopoverEl.focus();
                    e.preventDefault();
                }
            }
            else {
                // if tab key is pressed
                if (document.activeElement === this._lastFocusablePopoverEl) {
                    this._firstFocusablePopoverEl.focus();
                    e.preventDefault();
                    // if focused has reached to last focusable element then focus first focusable element after pressing tab
                }
            }
        }
        // ESCAPE KEY
        if (isEscapePressed) {
            this.pvdOpen = false;
        }
    };
    /**
     * Handles clicks outside the popover or popover trigger
     * @param e Mouse event object
     */
    PvdPopover.prototype.clickOutsideEventHandler = function (e) {
        if (!this._popoverElement.contains(e.target) &&
            !this._triggerElement.contains(e.target)) {
            // prevent calling the function if the `onClickOutside` has been set to `undefined`
            if (typeof this.onClickOutside !== 'undefined') {
                this.onClickOutside(e);
            }
        }
    };
    /**
     * Mutation Observer callback for when content within Popover gets changed
     *
     * @param mutationsList
     * @param observer
     */
    PvdPopover.prototype.contentChangeMutationEventHandler = function (mutationsList) {
        var _this = this;
        var mutations = mutationsList.filter(function (mutation) {
            // needed in order to support the change of an element that updates to display:none
            var validAttributeMutation = mutation.type === MutationType.attributes && mutation.attributeName === 'style';
            return (_this.pvdOpen &&
                (mutation.type === MutationType.characterData ||
                    mutation.type === MutationType.childList ||
                    validAttributeMutation));
        });
        if (mutations.length > 0) {
            this.isContentOverflowing();
            this.addFirstLastFocusableElements();
        }
    };
    // #endregion
    // #region LitElement lifecycles
    PvdPopover.prototype.updated = function (changedProperties) {
        _super.prototype.updated.call(this, changedProperties);
        if (changedProperties.has('pvdOpen')) {
            this.openStateChange();
        }
        if (changedProperties.has('pvdBoundary')) {
            this.boundaryStateChange();
        }
        if (changedProperties.has('pvdPlacement')) {
            this.placementStateChange();
        }
        if (changedProperties.has('pvdTarget')) {
            this.targetStateChange();
        }
        if (changedProperties.has('pvdZIndex')) {
            this.zIndexStateChange();
        }
    };
    PvdPopover.prototype.firstUpdated = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.firstUpdated.call(this);
                        // create observers if they don't exist
                        this.addContentChangeObserver();
                        // Popper.js sets global events that need Popover references;
                        // wait for component to full update before setup
                        return [4 /*yield*/, this.updateComplete];
                    case 1:
                        // Popper.js sets global events that need Popover references;
                        // wait for component to full update before setup
                        _a.sent();
                        // create references
                        this.addElementReferences();
                        // observe mutation observer
                        this.observeMutations();
                        // create popper instance
                        this.addPopperInstance();
                        return [2 /*return*/];
                }
            });
        });
    };
    PvdPopover.prototype.disconnectedCallback = function () {
        _super.prototype.disconnectedCallback.call(this);
        this.removeMutationObservers();
        this.removePopperInstance();
    };
    PvdPopover.prototype._getUpdateComplete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var popperUpdate;
            return __generator(this, function (_a) {
                popperUpdate = this.popper ? this.popper.update() : undefined;
                return [2 /*return*/, Promise.all([_super.prototype._getUpdateComplete.call(this), popperUpdate])];
            });
        });
    };
    PvdPopover.prototype.renderTrigger = function () {
        // this simply adds title accessibility text to the underlying trigger link
        // as nice as it would be, it is not possible to simply pass the attribute in to the slot
        this.addEventListener('slotchange', function (e) {
            // assignedWrapper comes from ApexSlots, need type definition (export ApexSlot class, most likely)
            // https://github.com/Fidelity-Green/apex-for-web/blob/cfdb7f3e692f897d486dca38bdeee4cd2ea76448/utilities/slots/lib/utils.ts#L25
            var _a;
            var slot = e.target; // TODO: cast as ApexSlot when we expose the type definition
            if (slot.name === 'trigger') {
                var triggerElement = (_a = slot.assignedWrapper) === null || _a === void 0 ? void 0 : _a.firstChild;
                if (!triggerElement) {
                    return;
                }
                // we will always set the aria-haspopup attribute on the trigger even if the consumer provides one
                triggerElement.pvdNativeButtonAttributes = { 'aria-haspopup': 'dialog' };
                triggerElement.pvdNativeAnchorAttributes = { 'aria-haspopup': 'dialog' };
            }
        });
        return x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), this.hasTrigger
            ? x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            <div\n              class=\"pvd-popover__trigger-wrapper\"\n              role=\"", "\"\n              tabindex=\"", "\"\n              @click=\"", "\"\n              @keydown=\"", "\"\n            >\n              <span class=\"pvd-popover__trigger-slot-a11y-text\"\n                >", "</span\n              >\n              <s-slot name=\"trigger\"></s-slot>\n            </div>\n          "], ["\n            <div\n              class=\"pvd-popover__trigger-wrapper\"\n              role=\"", "\"\n              tabindex=\"", "\"\n              @click=\"", "\"\n              @keydown=\"", "\"\n            >\n              <span class=\"pvd-popover__trigger-slot-a11y-text\"\n                >", "</span\n              >\n              <s-slot name=\"trigger\"></s-slot>\n            </div>\n          "])), l(this.pvdDisableTriggerSlotButton ? undefined : "button"), l(this.pvdDisableTriggerSlotButton ? undefined : "0"), this.triggerEventHandler, this.triggerKeyHandler, this.pvdTriggerButtonA11yText) : x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<s-slot name=\"trigger\"></s-slot>"], ["<s-slot name=\"trigger\"></s-slot>"]))));
    };
    PvdPopover.prototype.renderCloseIcon = function () {
        return this.scopeTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      <div class=\"pvd-popover__close-button-area\">\n        <button\n          class=\"pvd-popover__close-button\"\n          @click=\"", "\"\n          aria-describedby=\"", "\"\n          type=\"button\"\n        >\n          <span class=\"pvd-popover__close-button-a11y-text\">", "</span>\n          <pvd-scoped-icon pvd-name=\"action__close\" pvd-size=\"small\"></pvd-scoped-icon>\n        </button>\n      </div>\n    "], ["\n      <div class=\"pvd-popover__close-button-area\">\n        <button\n          class=\"pvd-popover__close-button\"\n          @click=\"", "\"\n          aria-describedby=\"", "\"\n          type=\"button\"\n        >\n          <span class=\"pvd-popover__close-button-a11y-text\">", "</span>\n          <pvd-scoped-icon pvd-name=\"action__close\" pvd-size=\"small\"></pvd-scoped-icon>\n        </button>\n      </div>\n    "])), this.closeButtonEventHandler, this.pvdAriaLabelledby || false, this.pvdCloseButtonA11yText);
    };
    PvdPopover.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-popover-root"),
            modifierPrefix: 'pvd-popover',
            modifiers: [
                {
                    condition: this.pvdOpen,
                    className: 'open',
                },
                {
                    condition: this.pvdContentOverflow,
                    className: 'content-overflow',
                },
                {
                    condition: this.pvdCurrentPlacement !== undefined,
                    className: "placement-".concat(this.pvdCurrentPlacement),
                },
            ],
        };
        return x(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      <div class=\"", "\" @keydown=\"", "\">\n        ", "\n        <div\n          aria-modal=\"true\"\n          class=\"pvd-popover__wrapper\"\n          id=\"", "\"\n          role=\"dialog\"\n          tabindex=\"", "\"\n        >\n          <div class=\"pvd-popover__popover\">\n            ", "\n            <div\n              class=\"pvd-popover__slot-area\"\n              id=\"", "\"\n              role=\"", "\"\n              tabindex=\"", "\"\n            >\n              <s-slot></s-slot>\n            </div>\n          </div>\n          <span class=\"pvd-popover__arrow\"></span>\n        </div>\n      </div>\n    "], ["\n      <div class=\"", "\" @keydown=\"", "\">\n        ", "\n        <div\n          aria-modal=\"true\"\n          class=\"pvd-popover__wrapper\"\n          id=\"", "\"\n          role=\"dialog\"\n          tabindex=\"", "\"\n        >\n          <div class=\"pvd-popover__popover\">\n            ", "\n            <div\n              class=\"pvd-popover__slot-area\"\n              id=\"", "\"\n              role=\"", "\"\n              tabindex=\"", "\"\n            >\n              <s-slot></s-slot>\n            </div>\n          </div>\n          <span class=\"pvd-popover__arrow\"></span>\n        </div>\n      </div>\n    "])), getClassName(classMap), this.keyboardEventHandler, this.renderTrigger(), this.pvdId || this.generatedPopoverId, this.pvdOpen ? '0' : '-1', this.renderCloseIcon(), l(this._generatedSlotAreaId), l(this.pvdContentOverflow ? 'region' : undefined), l(this.pvdContentOverflow ? '0' : undefined));
    };
    //#region Component configuration
    PvdPopover.componentName = 'popover';
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-describedby' }),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdAriaDescribedby", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-label' }),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdAriaLabel", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-labelledby' }),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdAriaLabelledby", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-boundary',
        }),
        __metadata("design:type", Object)
    ], PvdPopover.prototype, "pvdBoundary", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-close-button-a11y-text',
        }),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdCloseButtonA11yText", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: false, attribute: 'pvd-disable-focus' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-focus'))),
        __metadata("design:type", Boolean)
    ], PvdPopover.prototype, "pvdDisableFocus", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: false, attribute: 'pvd-disable-return-focus' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-return-focus'))),
        __metadata("design:type", Boolean)
    ], PvdPopover.prototype, "pvdDisableReturnFocus", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: false, attribute: 'pvd-disable-overflow' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-overflow'))),
        __metadata("design:type", Boolean)
    ], PvdPopover.prototype, "pvdDisableOverflow", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-disable-trigger-slot-button' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-trigger-slot-button'))),
        __metadata("design:type", Boolean)
    ], PvdPopover.prototype, "pvdDisableTriggerSlotButton", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-open' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-open'))),
        __metadata("design:type", Boolean)
    ], PvdPopover.prototype, "pvdOpen", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-trigger-button-a11y-text',
        }),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdTriggerButtonA11yText", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-placement',
        }),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdPlacement", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-id',
        }),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdId", void 0);
    __decorate([
        n({
            attribute: 'pvd-target',
        }),
        __metadata("design:type", Object)
    ], PvdPopover.prototype, "pvdTarget", void 0);
    __decorate([
        n({
            type: String,
            reflect: true,
            attribute: 'pvd-z-index',
        }),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdZIndex", void 0);
    __decorate([
        t(),
        __metadata("design:type", Boolean)
    ], PvdPopover.prototype, "pvdContentOverflow", void 0);
    __decorate([
        t(),
        __metadata("design:type", String)
    ], PvdPopover.prototype, "pvdCurrentPlacement", void 0);
    return PvdPopover;
}(ScopedElementsMixin(PvdSlotifyBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { DEFAULT_BOUNDARY, DEFAULT_CLOSE_BTN_A11Y_TEXT, DEFAULT_DISABLE_FOCUS, DEFAULT_DISABLE_OVERFLOW, DEFAULT_DISABLE_RETURN_FOCUS, DEFAULT_DISABLE_TRIGGER_SLOT_BUTTON, DEFAULT_OPEN, DEFAULT_PLACEMENT, DEFAULT_TRIGGER_TEXT_CONTENT, PvdPopover };
